export default __webpack_public_path__ + "static/media/p9.71c20600.jpg";